// Third Party Plugins
import React from 'react';
import Image from 'next/image';
// Types
import type { HeroHeadingProps } from './types';
// Styles
import {
  StyledHeroHeading,
  StyledHeroHeadingContent,
  StyledHeroHeadingContentHome,
} from './styles';
// Images
import wing from '@/assets/images/wing.png';

/**
 * HeroHeading component renders the heading for the Hero section.
 * @param {HeroHeadingProps} props - The props that are passed to the component.
 * @returns {JSX.Element} - The JSX markup for the component.
 */
const HeroHeading: React.FC<HeroHeadingProps> = ({
  children,
  home = false,
}) => {
  return (
    <StyledHeroHeading>
      {/* Render the wing images on the homepage */}
      {home && (
        <>
          <Image
            priority
            src={wing}
            className="wing wing-left"
            alt="left wing"
            data-testid="wing-left"
          />
          <Image
            priority
            src={wing}
            className="wing wing-right"
            alt="right wing"
            data-testid="wing-right"
          />
        </>
      )}
      {/* Gradient effects */}
      <div className="grad grad-right" />
      <div className="grad grad-left" />
      <div className="grad grad-top" />
      {/* Render different styles for the homepage and other pages */}
      {home ? (
        <StyledHeroHeadingContentHome>{children}</StyledHeroHeadingContentHome>
      ) : (
        <StyledHeroHeadingContent>{children}</StyledHeroHeadingContent>
      )}
      <div className="grad grad-bottom" />
    </StyledHeroHeading>
  );
};

export default HeroHeading;
